var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 159,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 0H0V100H100V0Z",
    fill: "url(#paint0_linear_2_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7792 20.8333L32.7208 29.775L29.775 32.725L20.8333 23.7792V31.25H16.6667V18.75C16.6667 17.6 17.6 16.6667 18.75 16.6667H31.25V20.8333H23.7792ZM32.7208 70.225L23.7792 79.1667H31.25V83.3333H18.75C17.6 83.3333 16.6667 82.4 16.6667 81.25V68.75H20.8333V76.2208L29.775 67.275L32.7208 70.225ZM20.8333 50C20.8333 53.125 24.8583 56.425 31.3292 58.6208L29.9958 62.5667C21.525 59.7 16.6667 55.1167 16.6667 50C16.6667 44.8833 21.525 40.3 29.9958 37.4333L31.3292 41.3792C24.8583 43.575 20.8333 46.875 20.8333 50ZM79.1667 68.75H83.3333V81.25C83.3333 82.4 82.4 83.3333 81.25 83.3333H68.75V79.1667H76.2208L67.275 70.225L70.2208 67.275L79.1667 76.2208V68.75ZM83.3333 18.75V31.25H79.1667V23.7792L70.2208 32.725L67.275 29.775L76.2208 20.8333H68.75V16.6667H81.25C82.4 16.6667 83.3333 17.6 83.3333 18.75ZM83.3333 50C83.3333 55.1167 78.475 59.7 70.0042 62.5667L68.6667 58.6208C75.1417 56.425 79.1667 53.125 79.1667 50C79.1667 46.875 75.1417 43.575 68.6667 41.3792L70.0042 37.4333C78.475 40.3 83.3333 44.8833 83.3333 50ZM50 64.175C45.0417 64.175 42.0292 62.9333 41.6667 62.6333V44.3792C44.0167 45.3583 47.0583 45.8333 50 45.8333C52.95 45.8333 55.9958 45.3583 58.35 44.375L58.4167 62.3C57.9708 62.9333 54.9583 64.175 50 64.175ZM50 37.5C54.8917 37.5 57.7417 38.9 58.2792 39.5833C57.7417 40.2667 54.8917 41.6667 50 41.6667C44.8792 41.6667 42 40.1333 41.6667 39.7125V39.6708C42 39.0333 44.8792 37.5 50 37.5ZM50 33.3333C43.9792 33.3333 37.5 35.2875 37.5 39.5833V62.6333C37.5 66.5792 43.7792 68.3417 50 68.3417C56.2208 68.3417 62.5 66.5792 62.5 62.6333V39.5833C62.5 35.2875 56.0208 33.3333 50 33.3333Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_2",
    x1: 0,
    y1: 100,
    x2: 100,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E27AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRds);
export default __webpack_public_path__ + "static/media/logo-rds.b2e8361455e800fdcf32bd299eade021.svg";
export { ForwardRef as ReactComponent };